import { render, staticRenderFns } from "./lookActivity.vue?vue&type=template&id=31d8cc9c"
import script from "./lookActivity.vue?vue&type=script&lang=js"
export * from "./lookActivity.vue?vue&type=script&lang=js"
import style0 from "./lookActivity.vue?vue&type=style&index=0&id=31d8cc9c&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d8cc9c')) {
      api.createRecord('31d8cc9c', component.options)
    } else {
      api.reload('31d8cc9c', component.options)
    }
    module.hot.accept("./lookActivity.vue?vue&type=template&id=31d8cc9c", function () {
      api.rerender('31d8cc9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/lookactivity/lookActivity.vue"
export default component.exports